import styled from 'styled-components';
import {Space} from 'antd';

const StyledInvoiceUploader = styled(Space)`
  width: 100%;
  
  .ant-upload.ant-upload-select {
    background: unset;
    justify-content: flex-start;
    padding: 0;
  }
`;

const StyledInvoiceUploaderListSpace = styled(Space)`
  width: 100%;
  
  .ant-space-item {
    align-items: center;
    display: flex;
  }
  
  .ant-space {
    justify-content: space-between;
    width: 100%;
  }
`;

export {
  StyledInvoiceUploader,
  StyledInvoiceUploaderListSpace,
};
